export default "__VITE_ASSET__CLOGWVNU__"